import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import { defineComponent, toRefs } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseSelect from "../base/base-select.vue";
import BaseLabel from "../base/base-label.vue";
import BaseFieldLayout from "../base/base-field-layout.vue";
export default defineComponent({
  name: "SelectField",
  components: {
    BaseLabel,
    BaseFieldLayout,
    BaseSelect
  },
  props: {
    value: {
      type: null,
      default: 0
    },
    options: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    showRequiredIndicator: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      value
    } = toRefs(props);
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput
    };
  }
});